import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
import Store from "store";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Router } from "routes";
// import TagManager from 'react-gtm-module'
import SearchIcon from '@material-ui/icons/Search';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import SeoMeta from '/components/seoMeta';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    layout: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 100,
        [theme.breakpoints.up('sm')]: {
            width: 900,
        },
        [theme.breakpoints.only('sm')]: {
            width: 650,
            padding: '0px 20px'
        },
        [theme.breakpoints.only('xs')]: {
            padding: '0px 20px'
        },
    },
    textField: {
      padding: '20px 0px',
      margin: '25px 0px 0px',
      width: '100%',
      // "& input":{
      //   fontFamily: "'Zawgyi-One','serif'",
      // }
    },
});

function CustomRadio(props) {
  return (
   <Radio
    checked={ props.isActiveRadio }
    onChange={ props.onActiveRadio }
    value={props.content}
    color="primary"
  />)
};
class Search extends Component {
  constructor(props){
    super(props);
    this.state = {
      types: [
        { id: 3, name: 'all'},
        { id: 1, name: 'articles'},
        { id: 2, name: 'videos'},
      ],
      type: 'all'
    };
  }
 
  setActiveRadio = (typeName) => {
    this.setState({ type : typeName })
  } 

  isActiveRadio(name) {
    return this.state.type === name
  }

  handleSubmit(that){
    that.preventDefault();
    if(this.state.q && this.state.type)
    Router.pushRoute(`/search-results?q=${this.state.q}&sc=${this.state.type}&page=1&sort=date`)
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Head>
          <title>Search Page</title>
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}/search`} 
            type="article"
            title='Search'
            description="Search"
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
            section='search'
            keywords='search'
          />        
        <NProgress />
        <div className={classes.layout}>
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: 40 }}>
            <form onSubmit={this.handleSubmit.bind(this)}>
              <TextField
                onChange={(event) => this.setState({q: event.target.value})}
                id="standard-search"
                placeholder="Type your keywords"
                type="search"
                value={this.state.q || ''}
                className={classes.textField}
                margin="normal"
                InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                            <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              {
                this.state.types.map((item, i) => {
                  return(
                    <FormControlLabel key={item.id} control={
                      <CustomRadio content={ item.name } 
                      isActiveRadio={ this.isActiveRadio(item.name) } 
                      onActiveRadio={ 
                        this.setActiveRadio.bind(this, item.name)
                      } />
                    } label={item.name} />
                  )
                })
                }
            </form>          
          </Grid>
        </Grid>
      </div>
      </div>
    );
  }
    componentDidMount () {

    }
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }

}


export default withStyles(styles)(Search);
    